import React from 'react';
import './index.scss';

interface IframeBlockedProps {
  parentOrigin?: string | null;
}

/**
 * Sanitize string for safe display (prevent XSS)
 */
function sanitizeForDisplay(input: string | null | undefined): string {
  if (!input) {
    return '';
  }
  const div = document.createElement('div');
  div.textContent = input;
  return div.innerHTML;
}

export const IframeBlocked: React.FC<IframeBlockedProps> = ({ parentOrigin }) => {
  const sanitizedOrigin = sanitizeForDisplay(parentOrigin);

  return (
    <div className="iframe-blocked-container">
      <div className="iframe-blocked-content">
        <div className="iframe-blocked-icon">
          <svg
            width="64"
            height="64"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
          >
            <path
              d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
              fill="currentColor"
            />
            <path
              d="M12 7c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1s1-.45 1-1V8c0-.55-.45-1-1-1zm0 8c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1z"
              fill="currentColor"
            />
          </svg>
        </div>
        <h1 className="iframe-blocked-title">Access Restricted</h1>
        <p className="iframe-blocked-message">
          This application cannot be embedded in this context for security reasons.
        </p>
        {sanitizedOrigin && (
          <p className="iframe-blocked-origin">
            Parent origin: <code>{sanitizedOrigin}</code>
          </p>
        )}
        <p className="iframe-blocked-info">
          This application can only be embedded in authorized domains. Please contact your
          administrator to get access.
        </p>
        <div className="iframe-blocked-actions">
          <button
            className="iframe-blocked-button"
            onClick={() => {
              // Use window.open with noopener for security
              window.open(window.location.href, '_blank', 'noopener,noreferrer');
            }}
            type="button"
          >
            Open in New Window
          </button>
        </div>
      </div>
    </div>
  );
};
